import api from "../../../store/AuthHeader";

const getAllMemberActivities = (subRoleId: number) => {
    return api.get("/MemberWorkActivity/GetAllDefaultWorkActivitiesByBMAMember/" + subRoleId);
};

const getUserSubRoles = () => {
    return api.get("/MemberWorkActivity/GetUserSubRoles");
};

const addDefaultWorkActivity = (subRoleId?: number) => {
    const url = subRoleId ? `/MemberWorkActivity/AddDefaultWorkActivity?subRoleId=${subRoleId}` : "/MemberWorkActivity/AddDefaultWorkActivity";
    return api.post(url);
};

const getWorkActivityCategories = (subRoleId: number) => {
    return api.get("/MemberWorkActivity/getWorkActivityCategories/" + subRoleId);
};

const getWorkActivitySubCategories = (id: any, subRoleId: number) => {
    return api.get(`/MemberWorkActivity/getWorkActivitySubCategories/${id}/${subRoleId}`);
};

const removeWorkActivitySubCategories = (id: any, subRoleId: number) => {
    return api.delete(`/MemberWorkActivity/${id}/${subRoleId}`);
};

const saveCategoryWorkActivities = (payload: any) => {
    return api.post(`/MemberWorkActivity/SaveJobCategoryWorkActivity`, payload);
};

const saveSubCategoryWorkActivities = (payload: any) => {
    return api.post(`/MemberWorkActivity/SaveJobSubCategoryWorkActivity`, payload);
};

const removeUserDefinedWorkActivityCategory = (id: any, subRoleId: number) => {
    return api.delete(`/MemberWorkActivity/DeleteUserDefinedWorkActivityCategory/${id}/${subRoleId}`);
};

export default {
    getAllMemberActivities,
    getUserSubRoles,
    addDefaultWorkActivity,
    getWorkActivityCategories,
    getWorkActivitySubCategories,
    removeWorkActivitySubCategories,
    saveCategoryWorkActivities,
    saveSubCategoryWorkActivities,
    removeUserDefinedWorkActivityCategory
};